import gql from "graphql-tag";

import { Fragment, Report, ReportReferent } from "../types";

import { UserMinimalFragment, USER_MINIMAL_FRAGMENT } from "./User";

export const REPORT_REFERENT_FRAGMENT = gql`
  fragment ReportReferentFragment on ReportReferent {
    id
    filledAt
    skippedAt
    referent {
      ...UserMinimalFragment
    }
    report {
      id
    }
    createdAt
    updatedAt
  }

  ${USER_MINIMAL_FRAGMENT}
`;

// prettier-ignore
export type ReportReferentFragment = Fragment<
  ReportReferent,
  Pick<ReportReferent, "id" | "filledAt" | "skippedAt" | "createdAt" | "updatedAt">
    & {
        report: Pick<Report, 'id'>;
        referent: UserMinimalFragment;
      }
>;
